import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { resolveLobbyReturnUrl } from '@low6-pickem/frontend-shared';
import {
  navigateToLobby,
  SQUARES_FROM_LOBBY_KEY,
  SQUARES_LOBBY_URL_KEY,
} from '@/utils/lobbyNavigation';

/**
 * Floating back control when the user arrived from the Lobby.
 * Matches Pick'em / Daily Reveal: circular chevron, navigates via lobbyReturn.
 */
export default function LobbyBackBar() {
  const [searchParams] = useSearchParams();
  const fromLobbyParam = searchParams.get('from') === 'lobby';

  useEffect(() => {
    if (fromLobbyParam) {
      sessionStorage.setItem(SQUARES_FROM_LOBBY_KEY, '1');
      const url = resolveLobbyReturnUrl(searchParams, SQUARES_LOBBY_URL_KEY);
      sessionStorage.setItem(SQUARES_LOBBY_URL_KEY, url);
    }
  }, [fromLobbyParam, searchParams]);

  const visible = fromLobbyParam || sessionStorage.getItem(SQUARES_FROM_LOBBY_KEY) === '1';
  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => navigateToLobby(searchParams)}
      aria-label="Back to Lobby"
      className="fixed top-3 left-3 z-50 flex items-center justify-center w-8 h-8 rounded-full bg-black/60 backdrop-blur-sm text-white hover:bg-black/80 transition-colors"
    >
      <ChevronLeft className="w-5 h-5 flex-shrink-0" strokeWidth={2.5} />
    </button>
  );
}
